// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_logo {
  width: 164px;
  height: auto;
}

.header_params {
  position: relative;
}

.header_notification {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: var(--couleur-secondaire);
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 2px;
  top: -10px;
}

.header_btn_primary {
  background-color: var(--couleur-principale);
  border: solid 2px var(--couleur-principale);
  border-radius: 15px;
  padding: 7px;
  color: var(--white-principale);
  min-width: 224px;
}

.header_btn_primary span {
  font-size: 15px;
  font-weight: 700;
}

.header_btn_secondary {
  border: solid 1px var(--gris-principale);
  border-radius: 15px;
  text-align: center;
  min-width: 224px;
}

.header_mon_compte {
  background-color: var(--couleur-dark);
  border: solid 2px var(--couleur-dark);
  border-radius: 15px;
  padding: 7px;
  color: var(--white-principale);
  margin-right: 10px;
  min-width: 224px;
  font-size: 15px;
  font-weight: 700;
}

.header_input {
  background-color: var(--gris-secondaire-2);
  display: flex;
  align-items: center;
  margin-left: 5%;
  padding-right: 10px;
  border-radius: 10px;
}

.header_input_field {
  all: unset;
  /* supprime TOUS les styles */
  flex: 1 1;
  font: inherit;
  /* récupère la police du parent */
  color: inherit;
  padding: 10px;
}

.header_input input:focus,
.header_input input:active {
  border: none;
  outline: none;
  box-shadow: none;
}

.header_span {
  margin: 5px;
  font-size: 15px;
  font-weight: 700;
}

/* =========================
   LOGO
========================= */
.header_logo {
  width: 164px;
  height: auto;
}

/* =========================
     SEARCH INPUT
  ========================= */
.search-section {
  flex: 1 1;
  margin: 0 20px;
  position: relative;
}

.search-content-v2 {
  display: flex;
  align-items: center;
  background: var(--gris-secondaire-2);
  border-radius: 30px;
  padding: 0 15px;
  height: 44px;
  transition: box-shadow 0.2s ease;
}

.search-content-v2:focus-within {
  background: var(--white-principale);
  box-shadow: 0 0 0 2px var(--couleur-principale);
}

.suggestion-box {
  position: absolute;
  top: 52px;
  width: 100%;
  background: var(--white-principale);
  border-radius: 14px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  max-height: 360px;
  overflow-y: auto;
  z-index: 2000;
}

.suggestion-item {
  padding: 12px 16px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.suggestion-item:hover {
  background: var(--gris-secondaire-2);
}

.suggestion-title {
  font-weight: 600;
}

.header_input {
  background-color: var(--gris-secondaire-2);
  display: flex;
  align-items: center;
  border-radius: 10px;
  padding-right: 10px;
}

.header_input_field {
  all: unset;
  /* reset total */
  flex: 1 1;
  font: inherit;
  color: inherit;
  padding: 10px;
}

.header_input input:focus,
.header_input input:active {
  border: none;
  outline: none;
  box-shadow: none;
}

.header_search_icon {
  font-size: 18px;
  color: black;
}

/* Focus UX */
.header_input:focus-within {
  outline: 2px solid var(--couleur-principale);
}

/* =========================
     ACTIONS (BOUTONS)
  ========================= */
.header_actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.header_btn_primary {
  background-color: var(--couleur-principale);
  border: 2px solid var(--couleur-principale);
  border-radius: 15px;
  padding: 7px 14px;
  color: var(--white-principale);
  display: flex;
  justify-content: center;
  align-items: center;
}

.header_btn_primary span {
  margin-left: 5px;
  color: var(--white-principale);
  font-size: 15px;
}

.header_btn_primary:hover {
  background-color: var(--couleur-secondaire);
  border: 2px solid var(--couleur-secondaire);
  cursor: pointer;
}

.header_btn_secondary {
  border: 1px solid var(--gris-principale);
  border-radius: 15px;
  padding: 6px 10px;
}

.header_span {
  margin: 5px;
  font-size: 15px;
}

.header_input_mobile {
  display: none;
}

.header_signin:hover {
  color: var(--couleur-secondaire);
}

.header_login:hover {
  color: var(--couleur-secondaire);
}

/* =========================
     RESPONSIVE
  ========================= */

@media (max-width: 1200px) {
  .header_input_mobile {
    display: block;
  }

  .header_input_desktop {
    display: none;
  }

  .header_input {
    width: 100%;
    margin: 10px 0;
  }

  .header_actions {
    flex-direction: column;
    width: 100%;
    margin-top: 15px;
  }

  .header_btn_primary,
  .header_btn_secondary,
  .header_mon_compte,
  .header_params {
    width: 100%;
    text-align: center;
  }

  .header_notification {
    top: 5px;
    right: 30px;
  }

  .header_btn_secondary {
    padding: 10px 0;
  }
}

@media (max-width: 991px) {
  .header_input_mobile {
    display: block;
  }

  .header_input_desktop {
    display: none;
  }

  .header_input {
    width: 100%;
    margin: 10px 0;
  }

  .header_actions {
    flex-direction: column;
    width: 100%;
    margin-top: 15px;
  }

  .header_btn_primary,
  .header_btn_secondary,
  .header_mon_compte,
  .header_params {
    width: 100%;
    text-align: center;
  }

  .header_notification {
    top: 5px;
    right: 30px;
  }

  .header_btn_secondary {
    padding: 10px 0;
  }
}

.category_bar {
  background: var(--white-principale);
  border-bottom: 1px solid var(--gris-secondaire);
  position: relative;
  margin-bottom: 20px;
}

/* Teto nisy modification */
.category_list {
  display: flex;
  justify-content: center;
  gap: 0px;
  list-style: none;
  margin: 0;
  padding: 0;
}

/* Teto nisy modification */
.category_item_group {
  padding: 15px 25px;
}

/* Supprimer le padding-left du premier li */
.category_list>.category_item_group:first-child {
  padding-left: 0;
}

.category_group_title {
  margin-left: 0 !important;
}

.category_group_header {
  cursor: pointer;
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-username); /* 13px, cohérent avec le reste du menu */
  color: var(--texte-principale);
  display: flex;
  align-items: center;
  gap: 4px;
}

.category_item_group:hover .category_mega_dropdown {
  display: block;
}

.category_mega_dropdown {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: var(--white-principale);
  box-shadow: 4px 5px 7px 2px rgba(0, 0, 0, 0.77);
  border-top: 1px solid var(--gris-principale);
  z-index: 1000;
  border-radius: 0 0 15px 15px;
}

.category_mega_dropdown.active {
  display: block;
}

.dropdown_container {
  margin: 0 auto;
  display: flex;
  min-height: 250px;
  border-radius: 10px;
}

/* --- SIDEBAR GAUCHE --- */
.dropdown_sidebar {
  flex: 0 0 280px;
  background-color: var(--gris-secondaire);
  padding: 30px;
}

.sidebar_title_wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 15px;
  justify-content: flex-start;
}

.sidebar_title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
}

.sidebar_icon {
  font-size: 20px;
  color: var(--couleur-principale);
  display: flex;
  align-items: center;
  transition: 0.2s ease;
}

.sidebar_title:hover .sidebar_icon {
  transform: scale(1.1);
}


.group_icon {
  font-size: 24px;
}

.sidebar_group_name {
  font-size: var(--font-size-seller-name); /* 16px */
  font-weight: var(--font-weight-title);
  margin: 0;
  color: var(--texte-principale);
}

.view_all_link {
  color: var(--couleur-principale);
  font-size: var(--font-size-badge); /* 12px */
  font-weight: var(--font-weight-medium);
  cursor: pointer;
}

.view_all_link:hover {
  text-decoration: underline;
}

.dropdown_main_content {
  flex: 1 1;
  padding: 30px 40px;
}

.dropdown_grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px 30px;
  list-style: none;
  padding: 0;
  margin: 0;
}

.dropdown_sub_item {
  font-size: var(--font-size-detail-text); /* 14px */
  font-weight: var(--font-weight-medium);
  color: var(--texte-principale);
  cursor: pointer;
  padding: 4px 0;
}

.dropdown_sub_item:hover {
  color: var(--couleur-principale);
  text-decoration: underline;
}

.category_item_group:hover .arrow_icon {
  transform: rotate(180deg);
}

.arrow_icon {
  transition: transform 0.2s;
}

.others_grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}

.other_group_name_bold {
  font-weight: var(--font-weight-title);
  color: var(--texte-principale);
  margin-bottom: 10px;
  text-transform: uppercase;
  font-size: var(--font-size-badge); /* 12px */
}


.other_sub_list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.other_sub_list li {
  font-size: var(--font-size-subcategory);
  font-weight: var(--font-weight-subcategory);
  color: var(--texte-principale);
  padding: 3px 0;
  cursor: pointer;
}

.other_sub_list li:hover {
  color: var(--couleur-principale);
  text-decoration: underline;
}

.others_container {
  max-width: 1000px;
  min-height: auto;
  padding-bottom: 30px;
}

.content_name_categorie_group {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
}

.category_mega_dropdown.d-block-mobile {
  display: block !important;
}

/* ========== MOBILE SIDEBAR ========== */

@media (max-width: 768px) {
  .category_mega_dropdown {
    display: none !important;
  }
}

.mobile_sidebar_overlay {
  position: fixed;
  inset: 0;
  background: var(--couleur-dark-primary);
  backdrop-filter: blur(4px);
  z-index: 3000;
  display: flex;
  justify-content: flex-start;
  animation: fadeIn 0.25s ease;
}

.mobile_sidebar {
  width: 100%;
  height: 100%;
  background: var(--white-principale);
  padding: 25px;
  overflow-y: auto;
  animation: slideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: -5px 0 25px var(--gris-principale);
}

.mobile_sidebar.closing {
  animation: slideOut 0.3s ease forwards;
}

/* .mobile_sidebar_overlay.closing {
  animation: fadeOut 0.3s ease forwards;
} */


.mobile_sidebar_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}

.group_name_mobile {
  color: var(--couleur-principale);
  font-weight: 700;
  margin-top: 3px;
}

.mobile_close_btn {
  border: none;
  background: transparent;
  font-size: 24px;
  cursor: pointer;
  color: var(--couleur-secondaire);
}

.mobile_sub_list {
  list-style: none;
  padding: 0;
}

.mobile_sub_list li {
  padding: 14px 0;
  border-bottom: 1px solid var(--white-secondaire);
  font-size: var(--font-size-subcategory);
  font-weight: var(--font-weight-subcategory);
  cursor: pointer;
  transition: 0.2s;
}

.mobile_sub_list li:hover {
  color: var(--couleur-principale);
  transform: translateX(4px);
}

.mobile_other_section {
  margin-bottom: 25px;
}

.dropdown_sub_item {
  font-size: var(--font-size-subcategory);
  font-weight: var(--font-weight-subcategory);
  color: var(--texte-principale);
  cursor: pointer;
  padding: 4px 0;
}

/* Animations */

@keyframes slideIn {
  from {
    transform: translateX(100%);
  }

  to {
    transform: translateX(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes slideOut {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(100%);
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}



@media (max-width: 1024px) {
  .category_bar {
    overflow-x: auto;
    white-space: nowrap;
    display: block;
    -webkit-overflow-scrolling: touch;
  }

  .category_list {
    display: inline-flex;
    /* padding: 0 15px; */
    justify-content: flex-start;
    gap: 20px;
  }

  .dropdown_container {
    max-width: 100%;
  }

  .dropdown_sidebar {
    flex: 0 0 220px;
    padding: 20px;
  }

  .dropdown_grid {
    grid-template-columns: 1fr;
  }

  .others_grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .category_bar {
    overflow-x: auto;
    white-space: nowrap;
    display: block;
    -webkit-overflow-scrolling: touch;
  }

  .category_bar::-webkit-scrollbar {
    display: none;
  }

  .category_list {
    display: inline-flex;
    /* padding: 0 15px; */
    justify-content: flex-start;
    gap: 20px;
  }

  .category_item_group {
    padding: 10px 0;
  }

  .category_mega_dropdown {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    border-radius: 0;
  }

  .dropdown_container {
    flex-direction: column;
    min-height: auto;
  }

  .dropdown_sidebar {
    flex: none;
    width: 100%;
    padding: 20px;
    border-bottom: 1px solid var(--gris-secondaire);
  }

  .dropdown_main_content {
    padding: 20px;
  }

  .dropdown_grid {
    grid-template-columns: 1fr;
  }

  .others_grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .arrow_icon {
    display: none;
  }

  .sidebar_title_wrapper {
    justify-content: space-between;
  }
}

@media (max-width: 480px) {
  .sidebar_group_name {
    font-size: 18px;
  }

  .dropdown_sub_item {
    padding: 12px 0;
    border-bottom: 1px solid var(--gris-secondaire-2);
  }
}

@media (max-width: 768px) {
  .search-section {
    margin: 0 10px;
  }

  .suggestion-box {
    top: 155px;
    position: fixed;
    left: 5%;
    width: 90%;
    max-height: 50vh;
    border-radius: 10px;
    box-shadow: 0 10px 25px var(--gris-principale);
    z-index: 9999;
  }

  .suggestion-item {
    padding: 14px 16px;
    font-size: 14px;
  }
}

/* =========================
     DESKTOP
  ========================= */
@media (min-width: 992px) {
  .category_bar {
    overflow-x: visible;
  }

  .category_list {
    justify-content: left;
  }
}

@media screen and (max-width: 1200px) {
  .header_container {
    width: 100%;
    padding: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/header/header.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,6BAA6B;EAC7B,SAAO;EACP,aAAa;EACb,iCAAiC;EACjC,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;;2BAE2B;AAC3B;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;;6BAE6B;AAC7B;EACE,SAAO;EACP,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mCAAmC;EACnC,mBAAmB;EACnB,2CAA2C;EAC3C,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,SAAO;EACP,aAAa;EACb,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,aAAa;AACb;EACE,4CAA4C;AAC9C;;AAEA;;6BAE6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;6BAE6B;;AAE7B;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,gBAAgB;EAClB;;EAEA;;;;IAIE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,gBAAgB;EAClB;;EAEA;;;;IAIE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mCAAmC;EACnC,+CAA+C;EAC/C,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,oCAAoC,EAAE,yCAAyC;EAC/E,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,mCAAmC;EACnC,+CAA+C;EAC/C,4CAA4C;EAC5C,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;EACE,eAAe;AACjB;;AAEA;EACE,uCAAuC,EAAE,SAAS;EAClD,qCAAqC;EACrC,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,iCAAiC,EAAE,SAAS;EAC5C,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,uCAAuC,EAAE,SAAS;EAClD,sCAAsC;EACtC,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC,EAAE,SAAS;AAC9C;;;AAGA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,2CAA2C;EAC3C,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yCAAyC;;AAEzC;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,uCAAuC;EACvC,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,aAAa;EACb,gBAAgB;EAChB,oDAAoD;EACpD,8CAA8C;AAChD;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;GAEG;;;AAGH;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gDAAgD;EAChD,uCAAuC;EACvC,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,2CAA2C;EAC3C,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA,eAAe;;AAEf;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;;;AAIA;EACE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,iCAAiC;EACnC;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,2BAA2B;IAC3B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,iCAAiC;EACnC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,2BAA2B;IAC3B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,aAAa;IACb,+CAA+C;EACjD;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iDAAiD;EACnD;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,QAAQ;IACR,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,8CAA8C;IAC9C,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;;6BAE6B;AAC7B;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,WAAW;IACX,UAAU;EACZ;AACF","sourcesContent":[".header_logo {\n  width: 164px;\n  height: auto;\n}\n\n.header_params {\n  position: relative;\n}\n\n.header_notification {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  background-color: var(--couleur-secondaire);\n  color: #fff;\n  font-size: 12px;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  right: 2px;\n  top: -10px;\n}\n\n.header_btn_primary {\n  background-color: var(--couleur-principale);\n  border: solid 2px var(--couleur-principale);\n  border-radius: 15px;\n  padding: 7px;\n  color: var(--white-principale);\n  min-width: 224px;\n}\n\n.header_btn_primary span {\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.header_btn_secondary {\n  border: solid 1px var(--gris-principale);\n  border-radius: 15px;\n  text-align: center;\n  min-width: 224px;\n}\n\n.header_mon_compte {\n  background-color: var(--couleur-dark);\n  border: solid 2px var(--couleur-dark);\n  border-radius: 15px;\n  padding: 7px;\n  color: var(--white-principale);\n  margin-right: 10px;\n  min-width: 224px;\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.header_input {\n  background-color: var(--gris-secondaire-2);\n  display: flex;\n  align-items: center;\n  margin-left: 5%;\n  padding-right: 10px;\n  border-radius: 10px;\n}\n\n.header_input_field {\n  all: unset;\n  /* supprime TOUS les styles */\n  flex: 1;\n  font: inherit;\n  /* récupère la police du parent */\n  color: inherit;\n  padding: 10px;\n}\n\n.header_input input:focus,\n.header_input input:active {\n  border: none;\n  outline: none;\n  box-shadow: none;\n}\n\n.header_span {\n  margin: 5px;\n  font-size: 15px;\n  font-weight: 700;\n}\n\n/* =========================\n   LOGO\n========================= */\n.header_logo {\n  width: 164px;\n  height: auto;\n}\n\n/* =========================\n     SEARCH INPUT\n  ========================= */\n.search-section {\n  flex: 1;\n  margin: 0 20px;\n  position: relative;\n}\n\n.search-content-v2 {\n  display: flex;\n  align-items: center;\n  background: var(--gris-secondaire-2);\n  border-radius: 30px;\n  padding: 0 15px;\n  height: 44px;\n  transition: box-shadow 0.2s ease;\n}\n\n.search-content-v2:focus-within {\n  background: var(--white-principale);\n  box-shadow: 0 0 0 2px var(--couleur-principale);\n}\n\n.suggestion-box {\n  position: absolute;\n  top: 52px;\n  width: 100%;\n  background: var(--white-principale);\n  border-radius: 14px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\n  max-height: 360px;\n  overflow-y: auto;\n  z-index: 2000;\n}\n\n.suggestion-item {\n  padding: 12px 16px;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.suggestion-item:hover {\n  background: var(--gris-secondaire-2);\n}\n\n.suggestion-title {\n  font-weight: 600;\n}\n\n.header_input {\n  background-color: var(--gris-secondaire-2);\n  display: flex;\n  align-items: center;\n  border-radius: 10px;\n  padding-right: 10px;\n}\n\n.header_input_field {\n  all: unset;\n  /* reset total */\n  flex: 1;\n  font: inherit;\n  color: inherit;\n  padding: 10px;\n}\n\n.header_input input:focus,\n.header_input input:active {\n  border: none;\n  outline: none;\n  box-shadow: none;\n}\n\n.header_search_icon {\n  font-size: 18px;\n  color: black;\n}\n\n/* Focus UX */\n.header_input:focus-within {\n  outline: 2px solid var(--couleur-principale);\n}\n\n/* =========================\n     ACTIONS (BOUTONS)\n  ========================= */\n.header_actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.header_btn_primary {\n  background-color: var(--couleur-principale);\n  border: 2px solid var(--couleur-principale);\n  border-radius: 15px;\n  padding: 7px 14px;\n  color: var(--white-principale);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.header_btn_primary span {\n  margin-left: 5px;\n  color: var(--white-principale);\n  font-size: 15px;\n}\n\n.header_btn_primary:hover {\n  background-color: var(--couleur-secondaire);\n  border: 2px solid var(--couleur-secondaire);\n  cursor: pointer;\n}\n\n.header_btn_secondary {\n  border: 1px solid var(--gris-principale);\n  border-radius: 15px;\n  padding: 6px 10px;\n}\n\n.header_span {\n  margin: 5px;\n  font-size: 15px;\n}\n\n.header_input_mobile {\n  display: none;\n}\n\n.header_signin:hover {\n  color: var(--couleur-secondaire);\n}\n\n.header_login:hover {\n  color: var(--couleur-secondaire);\n}\n\n/* =========================\n     RESPONSIVE\n  ========================= */\n\n@media (max-width: 1200px) {\n  .header_input_mobile {\n    display: block;\n  }\n\n  .header_input_desktop {\n    display: none;\n  }\n\n  .header_input {\n    width: 100%;\n    margin: 10px 0;\n  }\n\n  .header_actions {\n    flex-direction: column;\n    width: 100%;\n    margin-top: 15px;\n  }\n\n  .header_btn_primary,\n  .header_btn_secondary,\n  .header_mon_compte,\n  .header_params {\n    width: 100%;\n    text-align: center;\n  }\n\n  .header_notification {\n    top: 5px;\n    right: 30px;\n  }\n\n  .header_btn_secondary {\n    padding: 10px 0;\n  }\n}\n\n@media (max-width: 991px) {\n  .header_input_mobile {\n    display: block;\n  }\n\n  .header_input_desktop {\n    display: none;\n  }\n\n  .header_input {\n    width: 100%;\n    margin: 10px 0;\n  }\n\n  .header_actions {\n    flex-direction: column;\n    width: 100%;\n    margin-top: 15px;\n  }\n\n  .header_btn_primary,\n  .header_btn_secondary,\n  .header_mon_compte,\n  .header_params {\n    width: 100%;\n    text-align: center;\n  }\n\n  .header_notification {\n    top: 5px;\n    right: 30px;\n  }\n\n  .header_btn_secondary {\n    padding: 10px 0;\n  }\n}\n\n.category_bar {\n  background: var(--white-principale);\n  border-bottom: 1px solid var(--gris-secondaire);\n  position: relative;\n  margin-bottom: 20px;\n}\n\n/* Teto nisy modification */\n.category_list {\n  display: flex;\n  justify-content: center;\n  gap: 0px;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n/* Teto nisy modification */\n.category_item_group {\n  padding: 15px 25px;\n}\n\n/* Supprimer le padding-left du premier li */\n.category_list>.category_item_group:first-child {\n  padding-left: 0;\n}\n\n.category_group_title {\n  margin-left: 0 !important;\n}\n\n.category_group_header {\n  cursor: pointer;\n  font-weight: var(--font-weight-medium);\n  font-size: var(--font-size-username); /* 13px, cohérent avec le reste du menu */\n  color: var(--texte-principale);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.category_item_group:hover .category_mega_dropdown {\n  display: block;\n}\n\n.category_mega_dropdown {\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: var(--white-principale);\n  box-shadow: 4px 5px 7px 2px rgba(0, 0, 0, 0.77);\n  border-top: 1px solid var(--gris-principale);\n  z-index: 1000;\n  border-radius: 0 0 15px 15px;\n}\n\n.category_mega_dropdown.active {\n  display: block;\n}\n\n.dropdown_container {\n  margin: 0 auto;\n  display: flex;\n  min-height: 250px;\n  border-radius: 10px;\n}\n\n/* --- SIDEBAR GAUCHE --- */\n.dropdown_sidebar {\n  flex: 0 0 280px;\n  background-color: var(--gris-secondaire);\n  padding: 30px;\n}\n\n.sidebar_title_wrapper {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 15px;\n  justify-content: flex-start;\n}\n\n.sidebar_title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-weight: 700;\n}\n\n.sidebar_icon {\n  font-size: 20px;\n  color: var(--couleur-principale);\n  display: flex;\n  align-items: center;\n  transition: 0.2s ease;\n}\n\n.sidebar_title:hover .sidebar_icon {\n  transform: scale(1.1);\n}\n\n\n.group_icon {\n  font-size: 24px;\n}\n\n.sidebar_group_name {\n  font-size: var(--font-size-seller-name); /* 16px */\n  font-weight: var(--font-weight-title);\n  margin: 0;\n  color: var(--texte-principale);\n}\n\n.view_all_link {\n  color: var(--couleur-principale);\n  font-size: var(--font-size-badge); /* 12px */\n  font-weight: var(--font-weight-medium);\n  cursor: pointer;\n}\n\n.view_all_link:hover {\n  text-decoration: underline;\n}\n\n.dropdown_main_content {\n  flex: 1;\n  padding: 30px 40px;\n}\n\n.dropdown_grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px 30px;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.dropdown_sub_item {\n  font-size: var(--font-size-detail-text); /* 14px */\n  font-weight: var(--font-weight-medium);\n  color: var(--texte-principale);\n  cursor: pointer;\n  padding: 4px 0;\n}\n\n.dropdown_sub_item:hover {\n  color: var(--couleur-principale);\n  text-decoration: underline;\n}\n\n.category_item_group:hover .arrow_icon {\n  transform: rotate(180deg);\n}\n\n.arrow_icon {\n  transition: transform 0.2s;\n}\n\n.others_grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 30px;\n}\n\n.other_group_name_bold {\n  font-weight: var(--font-weight-title);\n  color: var(--texte-principale);\n  margin-bottom: 10px;\n  text-transform: uppercase;\n  font-size: var(--font-size-badge); /* 12px */\n}\n\n\n.other_sub_list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.other_sub_list li {\n  font-size: var(--font-size-subcategory);\n  font-weight: var(--font-weight-subcategory);\n  color: var(--texte-principale);\n  padding: 3px 0;\n  cursor: pointer;\n}\n\n.other_sub_list li:hover {\n  color: var(--couleur-principale);\n  text-decoration: underline;\n}\n\n.others_container {\n  max-width: 1000px;\n  min-height: auto;\n  padding-bottom: 30px;\n}\n\n.content_name_categorie_group {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 5px;\n}\n\n.category_mega_dropdown.d-block-mobile {\n  display: block !important;\n}\n\n/* ========== MOBILE SIDEBAR ========== */\n\n@media (max-width: 768px) {\n  .category_mega_dropdown {\n    display: none !important;\n  }\n}\n\n.mobile_sidebar_overlay {\n  position: fixed;\n  inset: 0;\n  background: var(--couleur-dark-primary);\n  backdrop-filter: blur(4px);\n  z-index: 3000;\n  display: flex;\n  justify-content: flex-start;\n  animation: fadeIn 0.25s ease;\n}\n\n.mobile_sidebar {\n  width: 100%;\n  height: 100%;\n  background: var(--white-principale);\n  padding: 25px;\n  overflow-y: auto;\n  animation: slideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: -5px 0 25px var(--gris-principale);\n}\n\n.mobile_sidebar.closing {\n  animation: slideOut 0.3s ease forwards;\n}\n\n/* .mobile_sidebar_overlay.closing {\n  animation: fadeOut 0.3s ease forwards;\n} */\n\n\n.mobile_sidebar_header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 25px;\n}\n\n.group_name_mobile {\n  color: var(--couleur-principale);\n  font-weight: 700;\n  margin-top: 3px;\n}\n\n.mobile_close_btn {\n  border: none;\n  background: transparent;\n  font-size: 24px;\n  cursor: pointer;\n  color: var(--couleur-secondaire);\n}\n\n.mobile_sub_list {\n  list-style: none;\n  padding: 0;\n}\n\n.mobile_sub_list li {\n  padding: 14px 0;\n  border-bottom: 1px solid var(--white-secondaire);\n  font-size: var(--font-size-subcategory);\n  font-weight: var(--font-weight-subcategory);\n  cursor: pointer;\n  transition: 0.2s;\n}\n\n.mobile_sub_list li:hover {\n  color: var(--couleur-principale);\n  transform: translateX(4px);\n}\n\n.mobile_other_section {\n  margin-bottom: 25px;\n}\n\n.dropdown_sub_item {\n  font-size: var(--font-size-subcategory);\n  font-weight: var(--font-weight-subcategory);\n  color: var(--texte-principale);\n  cursor: pointer;\n  padding: 4px 0;\n}\n\n/* Animations */\n\n@keyframes slideIn {\n  from {\n    transform: translateX(100%);\n  }\n\n  to {\n    transform: translateX(0);\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideOut {\n  from {\n    transform: translateX(0);\n  }\n\n  to {\n    transform: translateX(100%);\n  }\n}\n\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n}\n\n\n\n@media (max-width: 1024px) {\n  .category_bar {\n    overflow-x: auto;\n    white-space: nowrap;\n    display: block;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .category_list {\n    display: inline-flex;\n    /* padding: 0 15px; */\n    justify-content: flex-start;\n    gap: 20px;\n  }\n\n  .dropdown_container {\n    max-width: 100%;\n  }\n\n  .dropdown_sidebar {\n    flex: 0 0 220px;\n    padding: 20px;\n  }\n\n  .dropdown_grid {\n    grid-template-columns: 1fr;\n  }\n\n  .others_grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .category_bar {\n    overflow-x: auto;\n    white-space: nowrap;\n    display: block;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .category_bar::-webkit-scrollbar {\n    display: none;\n  }\n\n  .category_list {\n    display: inline-flex;\n    /* padding: 0 15px; */\n    justify-content: flex-start;\n    gap: 20px;\n  }\n\n  .category_item_group {\n    padding: 10px 0;\n  }\n\n  .category_mega_dropdown {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100%;\n    height: 100%;\n    overflow-y: auto;\n    border-radius: 0;\n  }\n\n  .dropdown_container {\n    flex-direction: column;\n    min-height: auto;\n  }\n\n  .dropdown_sidebar {\n    flex: none;\n    width: 100%;\n    padding: 20px;\n    border-bottom: 1px solid var(--gris-secondaire);\n  }\n\n  .dropdown_main_content {\n    padding: 20px;\n  }\n\n  .dropdown_grid {\n    grid-template-columns: 1fr;\n  }\n\n  .others_grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .arrow_icon {\n    display: none;\n  }\n\n  .sidebar_title_wrapper {\n    justify-content: space-between;\n  }\n}\n\n@media (max-width: 480px) {\n  .sidebar_group_name {\n    font-size: 18px;\n  }\n\n  .dropdown_sub_item {\n    padding: 12px 0;\n    border-bottom: 1px solid var(--gris-secondaire-2);\n  }\n}\n\n@media (max-width: 768px) {\n  .search-section {\n    margin: 0 10px;\n  }\n\n  .suggestion-box {\n    top: 155px;\n    position: fixed;\n    left: 5%;\n    width: 90%;\n    max-height: 50vh;\n    border-radius: 10px;\n    box-shadow: 0 10px 25px var(--gris-principale);\n    z-index: 9999;\n  }\n\n  .suggestion-item {\n    padding: 14px 16px;\n    font-size: 14px;\n  }\n}\n\n/* =========================\n     DESKTOP\n  ========================= */\n@media (min-width: 992px) {\n  .category_bar {\n    overflow-x: visible;\n  }\n\n  .category_list {\n    justify-content: left;\n  }\n}\n\n@media screen and (max-width: 1200px) {\n  .header_container {\n    width: 100%;\n    padding: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
